// Préférence d'e-mail : recevoir ou non les e-mails groupés.
import type { JSX } from 'preact'
import { useEffect, useState } from 'preact/hooks'
import type { FeedbaacksClient } from '@feedbaacks/sdk'
import { Spinner } from '@feedbaacks/ui'
import { d } from '../i18n'

export function Preferences({ client }: { client: FeedbaacksClient }): JSX.Element {
  const [enabled, setEnabled] = useState<boolean | null>(null)
  const [saved, setSaved] = useState(false)
  useEffect(() => {
    client.account.me().then((m) => setEnabled(m.notification_preferences.email_on_feedback_digest !== false), () => setEnabled(true))
  }, [client])
  if (enabled === null) return <div class="dash-center"><Spinner size={24} /></div>
  return (
    <div class="dash-page" data-testid="dash-preferences">
      <section class="dash-card">
        <label class="fb-check">
          <input type="checkbox" checked={enabled} data-testid="dash-digest"
            onChange={(e) => {
              const next = e.currentTarget.checked
              setEnabled(next)
              client.account.setEmailDigest(next).then(() => setSaved(true), () => setEnabled(!next))
            }} />
          <span>{d('preferences_digest')}</span>
        </label>
        {saved && <p class="fb-faint" role="status">{d('saved')}</p>}
      </section>
    </div>
  )
}
